// extracted by mini-css-extract-plugin
export default {"BackButton":"tFfHNuiX","BackButtonMobileIcon":"iLO_w3th","BackButtonDesktopIcon":"ILB8AHr_"};